import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { ExperimentService } from '@services/experiment/experiment.service';
import { EventLoggerService } from '@services/event-logger-service';

export enum ImprovementTimelinePlacement {
  REPORT = 'REPORT',
  REGIMEN = 'REGIMEN',
}

@Component({
  selector: 'app-improvement-timeline',
  templateUrl: './improvement-timeline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImprovementTimelineComponent implements OnInit {
  private readonly conn = inject(ConnectionService);
  private readonly experimentService = inject(ExperimentService);
  private readonly eventLogger = inject(EventLoggerService);

  placement = input.required<ImprovementTimelinePlacement>();
  regimenClass = input.required<string>();

  readonly timelineImage = signal<string | null>(null);

  async ngOnInit(): Promise<void> {
    if (!this.isEnabledForPlacement()) return;
    const regimenClass = this.regimenClass();
    if (!regimenClass) return;
    const timeline = await this.conn.getImprovementTimeline(regimenClass);
    if (!timeline?.timelineImage) return;
    this.timelineImage.set(timeline.timelineImage);
    this.logImpression();
  }

  private isEnabledForPlacement(): boolean {
    return this.placement() === ImprovementTimelinePlacement.REPORT
      ? this.experimentService.showImprovementTimelineOnReport
      : this.experimentService.showImprovementTimelineOnRegimen;
  }

  private logImpression(): void {
    this.eventLogger.cleverTapEvent('impression', JSON.stringify({
      name: 'improvement_timeline_shown',
      placement: this.placement(),
      class: this.regimenClass(),
    }));
  }
}
